import { useMemo, useEffect, useRef, useContext } from "react";
import { useForm } from "react-hook-form";
import Question from "../question";
import CartContext from "../../context/cart";
import useCartRequestUpdateMutation from "../../hooks/mutations/useCartRequestUpdateMutation";
import Icon from "../icon";

const CartHomeDelivery = () => {
  const { labels, survey, formData, setFormData, partial, campaign, cartRequest, handlePrevious } =
    useContext(CartContext);

  const section = useMemo(() => survey?.definition?.sections?.[7], [survey]);

  const {
    register,
    handleSubmit,
    control,
    reset,
    watch,
    trigger,
    formState: { errors, touchedFields, dirtyFields },
  } = useForm({
    mode: "onTouched",
    defaultValues: useMemo(() => formData, [formData]),
  });

  const formWatch = watch();
  const initializedFormData = useRef();

  useEffect(() => {
    if (initializedFormData.current) {
      reset(formData);
    }
  }, [reset, formData]);

  useEffect(() => {
    if (!initializedFormData.current && section?.questions) {
      initializedFormData.current = true;

      const initializedFields = {
        [section.questions?.[0]?.id]: cartRequest?.deliveryInformation?.destinatario,
        [section.questions?.[1]?.id]: cartRequest?.deliveryInformation?.indirizzo,
        [section.questions?.[2]?.id]: cartRequest?.deliveryInformation?.numeroCivico,
        [section.questions?.[3]?.id]: cartRequest?.deliveryInformation?.cap,
        [section.questions?.[4]?.id]: cartRequest?.deliveryInformation?.città,
        [section.questions?.[5]?.id]: cartRequest?.deliveryInformation?.provincia,
      };

      setFormData((current) => ({ ...current, ...initializedFields }));
    }
  }, [section, setFormData, survey, cartRequest]);

  const { mutateAsync: updateCartRequest } = useCartRequestUpdateMutation();

  const onSubmit = async (values) => {
    await updateCartRequest({
      campaignId: campaign?.id,
      cartRequest,
      survey,
      formData,
      values,
      partial,
      email: cartRequest?.welfareEmail,
      phone: cartRequest?.welfarePhone,
      deliveryInformation: {
        destinatario: values[section.questions[0].id],
        indirizzo: values[section.questions[1].id],
        numeroCivico: values[section.questions[2].id],
        cap: values[section.questions[3].id],
        city: values[section.questions[4].id],
        provincia: values[section.questions[5].id],
      },
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form cart-home-delivery__form" noValidate>
      {section.questions.map((question) => (
        <Question
          question={question}
          key={question.id}
          register={register}
          error={errors[`${question.id}`]}
          touched={touchedFields[`${question.id}`]}
          isDirty={dirtyFields[`${question.id}`]}
          control={control}
          trigger={trigger}
          labels={labels}
          value={formWatch[`${question.id}`]}
        />
      ))}
      <div className="form__buttons form__buttons--center">
        <button className="link" onClick={handlePrevious} type="button">
          <Icon name="angle-down" />
          {labels?.WELFARE_FORM_BTN_PREVIOUS || "Previous"}
        </button>
        <button className="button primary form__submit" onClick={handleSubmit}>
          {labels?.WELFARE_FORM_BTN_NEXT || "Next"}
        </button>
      </div>
    </form>
  );
};

export default CartHomeDelivery;
